// DO NOT USE THIS FILE FOR NEW CODE.
//
// If you think you need access to an object defined in this way
// in non-Webpack Javascript, you should actually just create a
// new Webpack bundle. Bundles are cheap, and inline Javascript
// should only be used for small, fully independent snippets using
// only native methods and locally scoped variables.

// Inherently dealing with dynamicglobal objects, so we need to use any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GlobalObject = Record<string, any>;

export function forcePath(pathStr: string): object {
  let globalObj;

  if (typeof window === 'object') {
    globalObj = window;
  } else if (typeof global === 'object') {
    globalObj = global;
  } else {
    throw new Error('no global object available');
  }

  return pathStr.split('.').reduce((curr: GlobalObject, next: string) => {
    if (typeof curr[next] === 'undefined') {
      curr[next] = {};
    }
    return curr[next];
  }, globalObj as GlobalObject);
}

// mimics Object.assign except first arg is a string path of the object you want to merge
// globalAssign('anObject.otherObj', {a: 1}, {b: 2})
// >> window.anOject.otherObj = {a: 1, b: 2}
export default function globalAssign(
  pathStr: string,
  ...assignees: object[]
): object {
  return Object.assign(forcePath(pathStr), ...assignees);
}
